import { OnInit, ElementRef } from '@angular/core';
import { BillingDetails } from 'app/shared/models/billing-details';
import { BillingService } from 'app/shared/services/billing.service';
import { AlertService } from 'app/shared/services/alert.service';
import { DacConfig } from 'app/shared/services/dac-config.service';
import { SubscriptionService } from '../services/subscription.service';
import { MetricsService } from 'app/shared/services/metrics.service';
var BillingPlansComponent = /** @class */ (function () {
    function BillingPlansComponent(billingService, alertService, dacConfig, subService, metrics) {
        this.billingService = billingService;
        this.alertService = alertService;
        this.dacConfig = dacConfig;
        this.subService = subService;
        this.metrics = metrics;
        this.METRICS_CATEGORY = 'SubscriptionUpgrade';
        this.cancellationReasons = [
            { id: 'tooExpensive', 'label': 'Your product is too expensive' },
            { id: 'understandHowToUse', 'label': 'I don’t understand how to use your product' },
            { id: 'betterProduct', 'label': 'I found something else I like better' },
            { id: 'missingKeyFeature', 'label': 'You’re missing a key feature I need' },
            { id: 'notUsingIt', 'label': 'I don’t use it like I thought I would' },
            { id: 'notMyDecision', 'label': 'It’s not my decision (someone else is having me cancel)' },
            { id: 'tooBuggy', 'label': 'Your product has too many glitches or technical problems' },
            { id: 'subscribeLater', 'label': "I'm not using this now but I plan on subscribing at a later point in time" },
            { id: 'cantAfford', 'label': "I can't afford this right now" }
        ];
        this.billingDetails = new BillingDetails();
    }
    Object.defineProperty(BillingPlansComponent.prototype, "hasSubscription", {
        get: function () {
            return this.billingDetails.subscriptions.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingPlansComponent.prototype, "stripeChargeName", {
        get: function () {
            return this.dacConfig.stripe_charge_name;
        },
        enumerable: true,
        configurable: true
    });
    BillingPlansComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.billingService.getBillingDetails()
            .then(function (details) {
            _this.billingDetails = details;
            _this.loading = false;
        })
            .catch(function (error) {
            _this.loading = false;
            console.error(error);
            _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'ngOnInit', 'failed to get billing details');
            _this.alertService.error("Failed to retrieve billing details from server.  Check your network connection and refresh the page.");
        });
    };
    BillingPlansComponent.prototype.upgradeTrialSubscription = function (subscription) {
        var _this = this;
        this.subscriptionAlertMessage = null;
        this.upgrading = true;
        // collect the payment credentials and update the card
        this.billingService.updateDefaultBillingCard(this.billingDetails)
            .then(function (updatedBillingDetails) {
            _this.billingDetails = updatedBillingDetails;
            // 
            _this.alertService.info("Billing card saved. Upgrading Subscription...");
            _this.subService.upgradeSubscription(subscription, _this.billingDetails)
                .then(function (billingDetails) {
                _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'upgradeTrialSubscription', 'subscription upgrade success');
                _this.billingDetails = billingDetails;
                _this.alertService.success("Subscription upgraded!");
                _this.upgrading = false;
            })
                .catch(function (error) {
                _this.upgrading = false;
                _this.subscriptionAlertMessage = error.message;
                _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'upgradeTrialSubscription', 'subscription upgrade failed ' + error.message);
            });
            // need to send subscription to server
            // end the free subscription
        })
            .catch(function (error) {
            _this.upgrading = false;
            if (error.code && error.code == 'canceled') {
                _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'upgradeTrialSubscription', 'billing card update canceled by customer');
                _this.subscriptionAlertMessage = "Billing card update was canceled.  A valid billing card must be provided before subscription can be upgraded";
            }
            else {
                console.error(error);
                _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'upgradeTrialSubscription', 'billing card update failed');
                _this.subscriptionAlertMessage = "There was an unexpected error in saving your billing card. Please try again or contact customer support";
            }
            _this.alertService.error("There was an error in saving your billing card. Please try again or contact customer support");
        });
    };
    BillingPlansComponent.prototype.updatePastDueBillingDetails = function (subscription) {
        var _this = this;
        this.upgrading = true;
        this.subscriptionAlertMessage = null;
        this.metrics.trackEvent(this.METRICS_CATEGORY, 'updatePastDueBillingDetails');
        this.billingService.updateDefaultBillingCard(this.billingDetails)
            .then(function (updatedBillingDetails) {
            _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'updatePastDueBillingDetails', 'Card update success');
            _this.billingDetails = updatedBillingDetails;
            _this.alertService.info("Billing card saved. Upgrading subscription payment...");
            _this.subService.updatePastDueSubscription(subscription, updatedBillingDetails)
                .then(function (billingDetails) {
                _this.upgrading = false;
                _this.billingDetails = billingDetails;
                var updatedSub = billingDetails.subscriptions.find(function (s) { return s.id == subscription.id; });
                if (updatedSub && updatedSub.isUnpaidSubscription()) {
                    _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'updatePastDueBillingDetails', 'Subscription past-due');
                    _this.subscriptionAlertMessage = "Our card processor could not immediately charge this card.  We will continue to attempt to charge this card over the next few hours, or you can try a different card.  Most cards should process within 24 hours.  Contact your card provider or our support for more assistance.";
                }
                else if (updatedSub && updatedSub.isActiveSubscription()) {
                    _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'updatePastDueBillingDetails', 'Subscription active');
                    _this.alertService.success("Subscription activated!");
                }
                else {
                    _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'updatePastDueBillingDetails', 'Subscription state other');
                    _this.alertService.error("There was an error in processing your subscription upgrade.  Contact support for assistance");
                }
            })
                .catch(function (error) {
                _this.upgrading = false;
                _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'updatePastDueBillingDetails', 'Subscription update failed');
                _this.alertService.error("There was an error in processing your subscription upgrade.  Contact support for assistance");
                console.error(error);
            });
            // end the free subscription
        })
            .catch(function (error) {
            _this.upgrading = false;
            _this.metrics.trackEvent(_this.METRICS_CATEGORY, 'updatePastDueBillingDetails', 'Card update failed');
            console.error(error);
            _this.alertService.error("There was an error in saving your billing card. Please try again or contact customer support");
        });
    };
    BillingPlansComponent.prototype.activateSubscription = function (subscription) {
        // activate the subscription
        // TODO: stephen do we want to support this?
    };
    BillingPlansComponent.prototype.startCancellation = function (subscription) {
        this.cancelConfirm = true;
        this.canceling = true;
        this.cancelReason = null;
    };
    BillingPlansComponent.prototype.cancelSubscription = function (subscription) {
        var _this = this;
        if (!this.cancelReason) {
            this.alertService.error("Please provide a reason for why you are cancelling.");
            console.error("No reason was selected but cancelSubscription called");
            return;
        }
        var cancelReason = this.cancelReason;
        if (cancelReason == 'Other') {
            cancelReason = this.cancelOtherReason.nativeElement.value;
            if (cancelReason.trim() == "") {
                this.alertService.error("Please provide a reason for why you are cancelling.");
                return;
            }
            else {
                cancelReason = "Other: " + cancelReason;
            }
        }
        else {
            var chosenReason = this.cancellationReasons.find(function (cr) { return cr.id == cancelReason; });
            if (!chosenReason) {
                this.alertService.error("Please provide a reason for why you are cancelling.");
                console.error("A reason provided, but was not in the cancellation array");
                return;
            }
            cancelReason = chosenReason.label;
        }
        console.log("Cancel reason is: ", cancelReason);
        this.subService.cancelSubscription(subscription, this.billingDetails, cancelReason)
            .then(function (billingDetails) {
            _this.billingDetails = billingDetails;
            _this.cancelConfirm = false;
            _this.canceling = false;
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.error(error.message);
        });
    };
    BillingPlansComponent.prototype.keepSubscription = function (subscription) {
        this.cancelConfirm = false;
        this.canceling = false;
    };
    BillingPlansComponent.prototype.isCancelChecked = function (reason) {
        return this.cancelReason == reason;
    };
    BillingPlansComponent.prototype.setCancelReason = function (reason) {
        this.cancelReason = reason;
    };
    BillingPlansComponent.prototype.hasCancelReason = function () {
        return this.cancelReason !== null;
    };
    BillingPlansComponent.prototype.getPlanItems = function (subscription) {
        return this.subService.getPlanDetailsForSubscription(subscription);
    };
    Object.defineProperty(BillingPlansComponent.prototype, "Billing", {
        get: function () {
            return this.billingDetails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingPlansComponent.prototype, "supportEmail", {
        get: function () {
            return this.dacConfig.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    return BillingPlansComponent;
}());
export { BillingPlansComponent };



// WEBPACK FOOTER //
// ./src/app/admin/billing-plans/billing-plans.component.ts.pre-build-optimizer.js